import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import {
  Clock,
  MapPin,
  ArrowRight,
  ArrowLeft,
  DollarSign,
} from "react-feather";
import Link from "next/link";

const MultiCardCarousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToDisplay, setItemsToDisplay] = useState(3);
  const [hoveredIndex, setHoveredIndex] = useState(-1); // -1 means no card is hovered

  useEffect(() => {
    const handleResize = () => {
      setItemsToDisplay(
        window.innerWidth <= 640
          ? 1
          : window.innerWidth <= 1024
            ? 2
            : window.innerWidth <= 1280
              ? 3
              : 3 // 1280px дээш дэлгэцэд 4 багана
      );
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(-1);
  };

  return (
    <Container maxWidth={"lgs"} disableGutters={true} className="">
      <Box mt={2}>
        <Box width="100%">
          <Box position="relative">
            <Box
              className="px-[45px] "
              display="grid"
              gridTemplateColumns={`repeat(${itemsToDisplay}, 1fr)`}
              gap={4}
            >
              {items
                .slice(currentIndex, currentIndex + itemsToDisplay)
                .map((card, index) => (
                  <Link
                    href={"/more/" + card.id}
                    passHref
                    key={card.id || index}
                  >
                    <Box
                      key={index}
                      className="shadow-md cursor-pointer relative overflow-hidden rounded-md "
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <Box
                        className={`w-full h-[250px] mb-4 object-cover rounded-md bg-cover bg-center transition-transform duration-500 ease-in-out ${
                          hoveredIndex === index ? "scale-105" : ""
                        }`}
                        style={{
                          backgroundImage: `url(${card.thumbnail})`,
                        }}
                      ></Box>
                      <Box className="px-4 h-[50px] line-clamp-2">
                        <h3 className="text-lg font-bold text-[#545454]">
                          {card.title}
                        </h3>
                        <Typography variant="body11">
                          {card.description}
                        </Typography>
                      </Box>
                      <Box className="px-4 ">
                        {/* Divider */}
                        <Box display="flex" justifyContent="center" my={2}>
                          <Box flex="1" borderTop="1px solid #b07f50"></Box>
                        </Box>

                        {/* Location and Time */}
                        <Box
                          display=""
                          justifyContent="space-between"
                          flexWrap="wrap"
                        >
                          {/* <Box
                            display="flex"
                            // alignItems="center"
                            className="mb-2  min-w-[200px]"
                          >
                            <MapPin size={20} color="gray" />
                            <Box ml={1} className="mt-[-6px]">
                              <Typography variant="body12">
                                {card.location}
                              </Typography>
                            </Box>
                          </Box> */}
                          <Box
                            display="flex"
                            alignItems="center"
                            className=" mb-2 ml-[2px]"
                          >
                            {/* <DollarSign size={15} color="gray" /> */}
                            <Box className="text-[16px] font-semibold text-[gray]">₮</Box>
                            <Box ml={1} className="mt-[-2px] font-semibold">
                              <Box className="text-[14px] font-semibold">
                                {card.price}
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            alignItems="center"
                            className=" mb-2"
                          >
                            <Clock size={16} color="gray" />
                            <Box ml={1} className="mt-[-2px]">
                              <Box className="text-[14px] font-semibold">
                                {card.time}
                              </Box>
                            </Box>
                          </Box>
                        </Box>

                        {/* Season and Travel Difficulties */}
                        <Box display="flex " justifyContent="" flexWrap="wrap">
                          <Box
                            display="flex"
                            alignItems="center"
                            className="min-w-[208px] ml-[2px]"
                          ></Box>
                        </Box>
                        <Box
                          textAlign="center"
                          className="p-[5px] m-[5px]"
                          sx={{
                            backgroundColor: "transparent", // Default background color
                            cursor: "pointer", // Changes cursor to pointer on hover
                            transition: "background-color 0.3s ease", // Smooth transition for background color
                            "&:hover": {
                              backgroundColor: "#f0f0f0", // Background color on hover
                            },
                          }}
                        >
                          <Typography
                            variant="body2"
                            className="text-[#243d7f] font-bold"
                          >
                            Дэлгэрэнгүй
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Link>
                ))}
            </Box>
            <Box className="flex justify-between mt-4 relative bottom-[300px] cursor-pointer">
              <Box
                className="w-10 h-10 rounded-full bg-[#cba47e] flex justify-center items-center relative right-0"
                onClick={handlePrev}
              >
                <ArrowLeft size={24} color="#fff" />
              </Box>
              <Box
                className="w-10 h-10 rounded-full bg-[#cba47e] flex justify-center items-center relative left-0"
                onClick={handleNext}
              >
                <ArrowRight size={24} color="#fff" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default MultiCardCarousel;
